export const Screens = {
  BUNDLE: 'bundle',
  COMMERCE: 'commerce',
  CONTENT: 'content',
  FREE: 'crm',
  MARKETING: 'marketing',
  HUBSPOT_FOR_MARKETERS: 'marketing-plus',
  DATA: 'data',
  SALES: 'sales',
  SERVICE: 'service',
  SMART_CRM: 'smart-crm',
  PLATFORM: 'suite'
};
export const PUBLIC_NAV_ITEMS = [Screens.PLATFORM, Screens.FREE, Screens.BUNDLE, Screens.HUBSPOT_FOR_MARKETERS, Screens.SMART_CRM, Screens.MARKETING, Screens.SALES, Screens.SERVICE, Screens.CONTENT, Screens.DATA, Screens.COMMERCE];
const PUBLIC_NAV_ITEMS_SET = new Set(PUBLIC_NAV_ITEMS);
export function isPublicNavItem(s) {
  return PUBLIC_NAV_ITEMS_SET.has(s);
}